import { indexData } from "@/mocks/homeData";

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2 font-heading">📂 内容分类索引</h2>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10">按类别快速浏览51吃瓜网站全部内容板块，精准定位你感兴趣的吃瓜方向</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => { e.preventDefault(); const el = document.querySelector("#cards"); if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: "smooth" }); }}
              className={`group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 cursor-pointer transition-all hover:border-primary-200/50 ${
                i === 0 ? "lg:col-span-2 bg-primary-50/50 border-primary-200/50" : ""
              }`}
            >
              <div className="flex items-start justify-between mb-3">
                <h3 className={`font-semibold leading-snug font-heading ${
                  i === 0 ? "text-base md:text-lg text-primary-700" : "text-sm md:text-base text-foreground-900"
                }`}>
                  {item.title}
                </h3>
                <span className={`text-xs font-bold whitespace-nowrap ml-2 flex-shrink-0 ${
                  i === 0 ? "text-primary-600" : "text-accent-600"
                }`}>
                  {item.count}
                </span>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}